<mat-drawer-container hasBackdrop>
  <mat-drawer autoFocus="false" #drawer mode="over" position="end" (closed)="close()">
  </mat-drawer>
  <mat-drawer-content>
    <div class="pcs-container">
      <div class="pcs-header">
        <h3 class="pcs-title">Product MBRs</h3>
        <div class="card-actions">
          @if (canCreate()) {
            <a
              (click)="onRequestMBR()"
              mat-flat-button
              color="primary"
              type="button"
              ><mat-icon>add</mat-icon> Request MBR</a>
            }
          </div>
        </div>
        <app-search-sort
          [searchControl]="searchControl"
          [sortForm]="sortForm"
          [sortOptions]="sortOptions"
          (apply)="setSortField()"
          (close)="resetSortField()"
        ></app-search-sort>
        <div class="pro-card column">
          <app-ag-grid-wrapper
            [data]="rowData"
            [columns]="columnDefs"
            (ready)="onGridReady($event)"
            />
            <mat-paginator
              #paginator
              [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
              [length]="totalCount"
              [pageIndex]="currentPage"
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSettings.pageSizeOptions"
              (page)="handlePageEvent($event)"
              aria-label="Select page"
              >
            </mat-paginator>
          </div>
        </div>

      </mat-drawer-content>
    </mat-drawer-container>
